<template>
  <v-dialog
  v-model="dialogEdit"
   max-width="500px"
 >
   <v-card>
     <v-card-title class="title-card">
       <span class="text-h5">{{ formTitle }}</span>
     </v-card-title>

     <v-card-text>
       <v-container>
        <v-form
            ref="form"
            v-model="valid"
          >
          <v-row>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-select
                v-model="obj.obra.id"
                :items="getObras"
                :rules="nameRules"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Unidades"
              ></v-select>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.pessoa.id"
                :items="getPessoas"
                :item-text="'nome'"
                :item-value="'id'"
                outlined
                label="Responsável"
              ></v-autocomplete>
            </v-col>
            <v-col
              class="d-flex"
              cols="12"
              sm="12"
              md="12"
            >
              <v-autocomplete
                v-model="obj.equipamento.id"
                :items="equipamentosConstrucao"
                :item-text="'descricao'"
                :item-value="'id'"
                outlined
                label="Equipamento"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
            >
              <v-text-field
                v-model="obj.descricao"
                required
                :rules="nameRules"
                label="Descrição"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.quantidade"
                required
                type="number"
                :rules="nameRules"
                label="Quantidade"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
            >
              <v-text-field
                v-model="obj.data_liberacao"
                v-mask="'##/##/####'"
                required
                :rules="nameRules"
                label="Data de liberação"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
       </v-container>
     </v-card-text>

     <v-card-actions class="d-flex">
      <v-row class="d-flex justify-end">
        <v-col cols="6">
          <v-btn
            color="primary"
            text
            @click="closeEditItem"
          >
            Cancelar
          </v-btn>
          <v-btn
            dark
            color="primary"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
     </v-card-actions>
   </v-card>
 </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import equipamentosConstrucao from '../../../../utils/materiais';
export default {
  /* eslint-disable */
 props:{
    dialogEdit: Boolean,
    objValue: Object,
   },
  data () {
    return {
      equipamentosConstrucao,
      valid:false,
      formTitle:'Editar',
      nameRules: [
          v => !!v || 'Campo requirido',
      ],
      dialog: false,
      obj: {
      descricao: '',
      nome:'',
      data_vencimento:'',
      },
    }
   },
   async created () {
    await this.getAllEmpresas();
    this.obj = this.objValue
  },
  /* eslint-disable */
  watch: {
    objValue(){
      this.obj = this.objValue
    }
  },
   methods: {
    ...mapActions('material', ['updateMaterial']),
    save() {
    this.$refs.form.validate()
      /* eslint-disable no-console */
      if (this.valid) {
        this.updateMaterial(
          {
            ...this.obj,
            pessoa: {
              ...this.getPessoas.find((item) => item.id === this.obj.pessoa.id)
            },
            obra: {
              ...this.getObras.find((item) => item.id === this.obj.obra.id)
            },
          })
        this.$emit('closeEditItem')
      }
    },
    async receber() {
      if (this.valid) {
        await this.updateValor({...this.obj, isPago: true})
        await this.updateMaterial({...this.obj, active: true})
        this.$emit('searchByFilter');
        this.$emit('closeEditItem');
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    closeEditItem () {
      this.$emit('closeEditItem')
    }  
 },
  computed: {
    ...mapGetters('pessoa', {getPessoas:'getList'}),
    ...mapGetters('obra', {getObras:'getList'}),
    customObj(){
      return {
        ...this.obj,
        obra: {
          ...this.getObras.find((item) => item.id === this.obj.obra.id)
        },
        descricao: this.obj.descricao,
        data_liberacao_timestamp: this.formatToDatastamp(this.obj.data_liberacao)
      }
    }
  },
}
</script>